// This file is bundled into the public code. Do not put secrets here.
// Generated by pre-build.ts — do not edit manually.

export const REACT_APP_API_URL = 'https://bioresponse-api-staging.dpi.nsw.gov.au';
export const REACT_APP_COGNITO_USER_POOL_ID = '{{ REACT_APP_COGNITO_USER_POOL_ID }}';
export const REACT_APP_COGNITO_USER_POOL_CLIENT_ID = '{{ REACT_APP_COGNITO_USER_POOL_CLIENT_ID }}';
export const REACT_APP_COGNITO_DOMAIN = '{{ REACT_APP_COGNITO_DOMAIN }}';
export const REACT_APP_DOMAIN = 'https://bioresponse-staging.dpi.nsw.gov.au';
export const REACT_APP_FIREBASE_API_KEY = 'AIzaSyBFTE8Jhs4b1FvElRrIqTi-TjGTRgoa1Dc';
export const REACT_APP_FIREBASE_AUTH_DOMAIN = 'bioresponse-8b6e9.firebaseapp.com';
export const REACT_APP_FIREBASE_PROJECT_ID = 'bioresponse-8b6e9';
export const REACT_APP_FIREBASE_STORAGE_BUCKET = 'bioresponse-8b6e9.appspot.com';
export const REACT_APP_FIREBASE_MESSAGING_SENDER_ID = '796773603706';
export const REACT_APP_FIREBASE_APP_ID = '1:796773603706:web:1ee839d5373fa1fbdb5ec3';
export const REACT_APP_FIREBASE_MEASUREMENT_ID = 'G-G46TPTS2YS';
export const REACT_APP_FIREBASE_VAPID = 'BH1MwdKmyhJCCn2vtoO-7HZKu4X62U0wW2qYP7urMLGxIvatTEhrNcJw0xHND5ZjQxxLpLyzBhXZTzA1MQKgaso';
